import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';

import Layout from './components/layout/Layout';
import RequireAuth from './components/auth/RequireAuth';

import MyHouses from './pages/houses/MyHouses';
import AddHouse from './pages/houses/HouseForm';
// import BroadlinkRegistration from './pages/appliances/BroadlinkRegistration';
// import ShellyRegistration from './pages/appliances/ShellyRegistration';
// import MyRooms from './pages/rooms/MyRooms';
// import AddRoom from './pages/rooms/AddRoom';
// import AirConditionsDashboard from './pages/appliances/AirConditionsDashboard';
// import ShellysDashboard from './pages/appliances/ShellysDashboard';
// import ShellyHandling from './pages/appliances/ShellyHandling';
// import AirConditionLearning from './pages/appliances/AirConditionLearning';
// import AirConditionHandling from './pages/appliances/AirConditionHandling';
import HouseReports_new from './pages/houses/HouseReports_new';
import Homepage_new from './pages/Homepage_new';
import SignUp from './pages/auth/SignUp';
import SignIn from './pages/auth/SignIn';
import Devices from './pages/Devices';
import GetStartedPage from './pages/GetStartedPage';

import { useUserContext } from './context/UserContext';
import { PageTitleProvider } from './context/PageTitleContext';
import { HouseDetailsProvider } from './context/HouseDetailsContext';

// const useRemoveUrlParams = () => {
//     useEffect(() => {
//         const url = new URL(window.location.href);
//         if (url.hash.includes('iss=')) {
//             const updatedHash = url.hash.replace(/(\?|&)iss=[^&]*(&|$)/, '$1').replace(/^#&/, '#');
//             window.history.replaceState(null, '', updatedHash);
//         }
//     }, []);
// };

// ScrollTo component: scrolls to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    // useRemoveUrlParams();

    const { token } = useUserContext();

    // Set axios base URL once
    axios.defaults.baseURL = 'https://hedgeiot.epu.ntua.gr/api';

    // Update axios headers when token changes
    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `${token}`;
        } else {
            delete axios.defaults.headers.common['Authorization'];
        }
    }, [token]);

    return (
        <Router>
            <PageTitleProvider>
                <ScrollToTop />
                <Routes>
                    {/* Standalone route for Get Started page (not in menu) */}
                    <Route path="/get-started" element={<GetStartedPage />} />

                    <Route path="/" element={<HouseDetailsProvider><Layout /></HouseDetailsProvider>}>
                        {/* Public Routes */}
                        <Route index element={<Homepage_new />} />
                        <Route path="signin" element={<SignIn />} />
                        {/* <Route path="signup" element={<SignUp />} /> */}

                        {/* Protected Routes */}
                        <Route element={<RequireAuth />}>
                            <Route path="houses" element={<MyHouses />} />
                            <Route path="add/house" element={<AddHouse />} />
                            <Route path="house/:id/edit" element={<AddHouse />} />
                            <Route path="house/id/:id/reports" element={<HouseReports_new />} />
                            <Route path="house/id/:id/devices" element={<Devices />} />

                            {/* <Route path="rooms" element={<MyRooms />} />
                            <Route path="rooms/house/:id" element={<MyRooms />} />
                            <Route path="add/room" element={<AddRoom />} />
                            <Route path="broadlink/add/house/id/:houseId" element={<BroadlinkRegistration />} />
                            <Route path="shelly/add/house/id/:houseId" element={<ShellyRegistration />} />
                            <Route path="airconditions/dashboard" element={<AirConditionsDashboard />} />
                            <Route path="shellys/dashboard" element={<ShellysDashboard />} />
                            <Route path="controller/aircondition/learning/:id" element={<AirConditionLearning />} />
                            <Route path="controller/aircondition/handling/:id" element={<AirConditionHandling />} />
                            <Route path="controller/shelly/handling/:id" element={<ShellyHandling />} /> */}
                        </Route>
                    </Route>
                </Routes>
            </PageTitleProvider>
        </Router>
    );
}

export default App;
